<div class="modal-body" class="p-col-12">
  <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
               size="default"
               color="#2f9cf2"
               type="ball-clip-rotate"
               [fullScreen]="false">
    <p style="color: white" >Loading... </p>
  </ngx-spinner>

  <div *ngIf="timesheets !== null && timesheets.length > 0">
    <p-card header="Man Hours by Month" [styleClass]="'p-shadow-5 title-center card-title-small'">
      <ng-template pTemplate="header">
        <div class="card-header-highlight"></div>
      </ng-template>
      <p-table [scrollable]="true" scrollDirection="horizontal">
        <ng-template pTemplate="header">
          <tr class="table-info">
            <th class="p-text-center bordered" style="min-width:100px;justify-content: center;" *ngFor="let month of monthList">{{month}}</th>
          </tr>
          <tr>
            <th class="p-text-center bordered" style="min-width:100px;justify-content: center;" *ngFor="let month of monthList">
              {{hoursByMonth[month]}}
            </th>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card header="Timesheet Details" [styleClass]="'p-shadow-5 title-center card-title-small p-mt-3'">
      <ng-template pTemplate="header">
        <div class="card-header-highlight"></div>
      </ng-template>
      <ag-grid-angular
        #topGrid
        style="height:180px;"
        class="ag-theme-alpine"
        [context]="context"
        [rowData]="timesheets"
        [columnDefs]="gridHeaders"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
      </ag-grid-angular>
    </p-card>
  </div>
  <p-messages [(value)]="messages"
              [closable]="false"
              [enableService]="false"
              *ngIf="timesheets !== null && timesheets.length === 0"></p-messages>
</div>

<div class="modal-footer">
  <button pButton pRipple label="Close" class="p-button-sm p-button-raised" icon="pi pi-times" type="button" (click)="cancel();"></button>
</div>

